<div class="editor-header">
  <div class="editor-heading">
    <div class="editor-heading-title">
      <mat-icon>auto_awesome</mat-icon>
      <span>{{ title }}</span>
    </div>
    <p>Registra sacramentos y bendiciones del miembro.</p>
  </div>
</div>

<div class="religious-event-layout">
  <div *ngIf="visibleReligiousEvents.length" class="religious-events-summary">
    <div class="religious-events-summary__title">Eventos espirituales registrados</div>
    <table class="religious-events-summary__table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Evento</th>
          <th>Lugar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of visibleReligiousEvents">
          <td>{{ formatDate(event.eventDate) }}</td>
          <td>{{ event.eventTypeName }}</td>
          <td>{{ event.locationOrganizationUnitName || event.location || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="editor-form">
  <div class="form-grid">
    <app-date-picker
      label="Fecha"
      formControlName="eventDate"
      [errorMessages]="{ required: 'Requerida' }">
    </app-date-picker>

    <mat-form-field>
      <mat-label>Evento espiritual</mat-label>
      <input
        matInput
        [formControl]="religiousEventSearchControl"
        [matAutocomplete]="religiousEventAuto"
        autocomplete="off" />
      <button
        *ngIf="form.get('religiousEventType')?.value"
        mat-icon-button
        matSuffix
        type="button"
        (click)="clearReligiousEventType()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        #religiousEventAuto="matAutocomplete"
        [displayWith]="displayReligiousEventOption.bind(this)">
        <ng-container *ngFor="let group of filteredReligiousEventGroups$ | async">
          <mat-optgroup [label]="group.label">
            <mat-option
              *ngFor="let option of group.options"
              [value]="option"
              (onSelectionChange)="option && $event.isUserInput && onReligiousEventTypeSelected(option)">
              {{ option.label }}
            </mat-option>
          </mat-optgroup>
        </ng-container>
      </mat-autocomplete>
      <mat-error *ngIf="religiousEventSearchControl.hasError('required')">Requerido</mat-error>
    </mat-form-field>
  </div>

  <div class="form-grid">
    <div class="field-full related-person-block">
      <label class="related-person-label">Lugar</label>

      <mat-radio-group formControlName="placeMode" class="related-person-mode">
        <mat-radio-button value="unit">Unidad organizacional</mat-radio-button>
        <mat-radio-button value="location">Otro lugar</mat-radio-button>
      </mat-radio-group>

      <app-unit-selector
        *ngIf="placeMode === 'unit'"
        label="Lugar"
        [required]="true"
        [unitSource]="'all'"
        [groupByLevel]="true"
        groupByMode="ancestors"
        formControlName="locationOrganizationUnitId">
      </app-unit-selector>

      <mat-form-field *ngIf="placeMode === 'location'" class="field-full">
        <mat-label>Lugar</mat-label>
        <input matInput formControlName="location" />
        <mat-error *ngIf="form.get('location')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('location')?.hasError('maxlength')">Máximo 200 caracteres</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field *ngIf="isWeddingAnniversary">
      <mat-label>Aniversario</mat-label>
      <mat-select formControlName="anniversaryYears">
        <mat-option *ngFor="let option of anniversaryOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('anniversaryYears')?.hasError('required')">Requerido</mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="supportsRelatedPerson" class="form-grid">
    <div class="field-full related-person-block">
      <label class="related-person-label">Persona relacionada</label>

      <mat-radio-group formControlName="relatedPersonMode" class="related-person-mode">
        <mat-radio-button value="system">Seleccionar una persona del sistema</mat-radio-button>
        <mat-radio-button value="manual">Escribir el nombre</mat-radio-button>
        <mat-radio-button value="none">No informar</mat-radio-button>
      </mat-radio-group>

      <mat-form-field *ngIf="relatedPersonMode === 'system'" class="field-full">
        <mat-label>Persona del sistema</mat-label>
        <input
          matInput
          [formControl]="relatedPersonSearchControl"
          [matAutocomplete]="relatedPersonAuto"
          autocomplete="off" />
        <button
          *ngIf="form.get('relatedPersonId')?.value"
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearSelectedRelatedPerson()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          #relatedPersonAuto="matAutocomplete"
          [displayWith]="displayPersonOption.bind(this)">
          <mat-option
            *ngFor="let option of filteredPeople$ | async"
            [value]="option"
            (onSelectionChange)="option && $event.isUserInput && onRelatedPersonSelected(option)">
            <div class="related-person-option">
              <span>{{ option.name }}</span>
              <small *ngIf="option.subtitle">{{ option.subtitle }}</small>
            </div>
          </mat-option>
        </mat-autocomplete>
        <mat-hint>Escribí al menos 2 caracteres para buscar.</mat-hint>
        <mat-error *ngIf="form.get('relatedPersonId')?.hasError('required')">Requerida</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="relatedPersonMode === 'manual'" class="field-full">
        <mat-label>Nombre de la persona relacionada</mat-label>
        <input matInput formControlName="relatedPersonName" />
        <mat-error *ngIf="form.get('relatedPersonName')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('relatedPersonName')?.hasError('maxlength')">Máximo 200 caracteres</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="form-grid">
    <app-optional-field
      class="field-full"
      [formControls]="form.get('notes')!"
      triggerLabel="Agregar notas"
      removeTooltip="Quitar notas">
      <mat-form-field class="field-full">
        <mat-label>Notas</mat-label>
        <textarea matInput rows="4" formControlName="notes"></textarea>
      </mat-form-field>
    </app-optional-field>
  </div>

  <div class="form-actions">
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="isSaving">
      <mat-icon>{{ currentEvent ? 'save' : 'add' }}</mat-icon>
      <span *ngIf="!isSaving">{{ currentEvent ? 'Guardar cambios' : 'Guardar' }}</span>
      <span *ngIf="isSaving">Guardando...</span>
    </button>
  </div>
  </form>
</div>
